var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"bucket-btn",class:{ 'fill-with-bucket' : _vm.isFilledColors },attrs:{"icon":"mdi mdi-format-color-fill"},on:{"click":function($event){_vm.isFilledColors = !_vm.isFilledColors}}})}
var staticRenderFns = []

export { render, staticRenderFns }